import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from "@angular/core";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { AcademicGrid } from "./s25.academic.grid";

@Component({
    standalone: true,
    selector: "s25-ng-academic-grids-warning-icon",
    host: {
        "[attr.data-warning-level]": "warningLevel()",
    },
    template: `
        @switch (warningLevel()) {
            @case ("ignore") {
                <!-- No icon for ignored -->
            }
            @case ("info") {
                <s25-ng-icon [type]="'info'" [ariaLabel]="'ignore'" />
            }
            @case ("warn") {
                <s25-ng-icon [type]="'warningYield'" [ariaLabel]="'warn'" />
            }
            @case ("prevent") {
                <s25-ng-icon [type]="'close'" [ariaLabel]="'prevent'" />
            }
        }
    `,
    styles: `
        :host {
            align-content: center;
        }

        :host[data-warning-level="info"] s25-ng-icon {
            color: var(--color--link-text);
        }

        :host[data-warning-level="warn"] s25-ng-icon {
            color: var(--color--warning);
        }

        :host[data-warning-level="prevent"] s25-ng-icon {
            color: var(--color--danger);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25IconComponent],
})
export class AcademicGridsWarningIconComponent {
    readonly warningLevel = input.required<AcademicGrid.WarningLevel>();
}
